import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLuisterendOor = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M11 28.13A6.68 6.68 0 0 0 17.4 35a6.5 6.5 0 0 0 6.6-6.5v-1.69a11 11 0 1 0-12.92-12.14z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M23.15 8a7.47 7.47 0 0 0-6 2.33.83.83 0 0 0 1 1.32 7 7 0 0 1 9.94 6.9.65.65 0 0 0 1.23.3 7.5 7.5 0 0 0 .79-3.63A7.57 7.57 0 0 0 23.15 8M18.12 19.44h-.11a.69.69 0 0 0-.61 1.12 2.8 2.8 0 0 1-1 4.18 2.81 2.81 0 0 0 3.99-2.99 2.85 2.85 0 0 0-2.27-2.31"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M23 8.5a7.71 7.71 0 0 0-7.71 7.71h-1A8.71 8.71 0 0 1 23 7.5zM15.29 16.21a2.43 2.43 0 0 0 2.43 2.43v1a3.43 3.43 0 0 1-3.43-3.43zM19.438 20.352a2.43 2.43 0 0 0-1.718-.712v-1a3.43 3.43 0 0 1 3.43 3.43h-1a2.43 2.43 0 0 0-.712-1.718M19.438 23.788a2.43 2.43 0 0 0 .712-1.718h1a3.43 3.43 0 0 1-3.43 3.43v-1a2.43 2.43 0 0 0 1.718-.712M15.29 22.07a2.43 2.43 0 0 0 2.43 2.43v1a3.43 3.43 0 0 1-3.43-3.43z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLuisterendOor);

export default ForwardRef;
